'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Breadcrumb = require('./Breadcrumb');

Object.defineProperty(exports, 'Breadcrumb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Breadcrumb).default;
  }
});

var _BreadcrumbItem = require('./BreadcrumbItem');

Object.defineProperty(exports, 'BreadcrumbItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BreadcrumbItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/breadcrumb/index.js
// module id = 549
// module chunks = 0